<template>
  <a
    href="#"
    class="verification-type"
    @click="(event) => { event.preventDefault(); $emit('select')}"
  >
    <div class="verification-type__inner">
      <div class="verification-type__title">
        <h2>{{ title }}</h2>
        <p class="verification-type__description">{{ description }}</p>
      </div>
      <div class="verification-type__image">
        <img
          :src="`${publicPath}img/${image}`"
          alt=""
        >
      </div>
    </div>
  </a>
</template>

<script>
export default {
  props: {
    title: String,
    description: String,
    image: String,
  },
  data() {
    return {
      publicPath: process.env.BASE_URL,
    };
  },
};
</script>
